export const sideNavBar = "#001e2d";
export const sideNavBarHover = "#001b29";
export const fontColor = "#31475f";
export const primaryColor = "#c4ca18";
export const lightBackground = "#f6f7f9";
